import { apiFetch, apiAction } from 'utils';

import * as constants from '../constants/index';

export default (email) =>
  apiAction(constants.BEGIN_SAVING_EMAIL, constants.SUCCESS_SAVING_EMAIL, constants.ERROR_SAVING_EMAIL,
    (state) =>
      apiFetch.post(
        state,
        'emails/',
        email
      ),
    {}
  );

export const previewEmail = (email) =>
  apiAction(constants.BEGIN_EMAIL_PREVIEW, constants.SUCCESS_EMAIL_PREVIEW, constants.ERROR_EMAIL_PREVIEW,
    (state) =>
      apiFetch.post(
        state,
        'preview_emails/',
        email
      ),
    {}
  );
